module.exports = {"audiences":["allMembers"],"experimentVersion":"v3","experimentAllocation":0.4,"defaultWeight":1,"defaults":{"showSurvey":false},"autoTrack":true,"variations":[{"name":"showSurvey","weight":1,"values":{"showSurvey":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/npsSurvey.json
// module id = 2dSL
// module chunks = 0